// for get all users
export const GET_USERS_INFO = "get_users_info_info";
export const GET_USERS_INFO_SUCCESS = "get_users_info_info_success";
export const GET_USERS_INFO_FAILURE = "get_users_info_info_failure";
